var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClueyHubOnBoarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 146.341,
    viewBox: "0 0 160 146.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9734",
    "data-name": "Group 9734",
    transform: "translate(-900 -329.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9734-2",
    "data-name": "Group 9734",
    transform: "translate(1006.667 385.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7396",
    "data-name": "Path 7396",
    d: "M64.333,8.5H21a5,5,0,1,0,0,10H64.333a5,5,0,0,0,0-10Z",
    transform: "translate(-16 -8.5)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7397",
    "data-name": "Path 7397",
    d: "M64.333,11.5H21a5,5,0,1,0,0,10H64.333a5,5,0,1,0,0-10Z",
    transform: "translate(-16 8.5)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7398",
    "data-name": "Path 7398",
    d: "M64.333,14.5H21a5,5,0,1,0,0,10H64.333a5,5,0,1,0,0-10Z",
    transform: "translate(-16 25.5)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7399",
    "data-name": "Path 7399",
    d: "M64.333,17.5H21a5,5,0,0,0,0,10H64.333a5,5,0,0,0,0-10Z",
    transform: "translate(-16 42.5)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7400",
    "data-name": "Path 7400",
    d: "M64.333,20.5H21a5,5,0,0,0,0,10H64.333a5,5,0,0,0,0-10Z",
    transform: "translate(-16 59.5)",
    fill: "#90a4ae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    d: "M11.667,98.5h70A11.723,11.723,0,0,0,93.333,86.833V20.167A11.723,11.723,0,0,0,81.667,8.5h-70A11.723,11.723,0,0,0,0,20.167V86.833A11.723,11.723,0,0,0,11.667,98.5Z",
    transform: "translate(900 377.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9735",
    "data-name": "Group 9735",
    transform: "translate(926.667 409.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7402",
    "data-name": "Path 7402",
    d: "M9,36a5.036,5.036,0,0,1-5-5V28.533C4,21.6,10.267,16,18,16H30c7.733,0,14,5.6,14,12.533V31a5.036,5.036,0,0,1-5,5Z",
    transform: "translate(-4 10.667)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2004",
    "data-name": "Ellipse 2004",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(10)",
    fill: "#42a5f5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18794",
    "data-name": "Rectangle 18794",
    width: 160,
    height: 40,
    rx: 4,
    transform: "translate(900 329.333)",
    fill: "#42a5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClueyHubOnBoarding);
export default __webpack_public_path__ + "static/media/cluey-hub-on-boarding.4a5da43d77060f452fab3bec2dfcbfbd.svg";
export { ForwardRef as ReactComponent };